import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Form, FormGroup, Input, Label } from 'reactstrap';
import UserSelectComponent from '../../components/shared/GlobalComponent/UserSelectComponent';
import { createSchedulerParlour } from '../../api/scheduler-parlour';
import { toast } from 'react-toastify';

function FormParlour(props) {
  const getDateNow = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const [form, setForm] = React.useState({
    username: '',
    suite_title: '',
    price: '',
    start_date: getDateNow()
  });
  const handleChange = (e, name) => {
    setForm({
      ...form,
      [name ?? e.target.name]: e.target.type === "file" ? (e.target.files.length ? e.target.files[0] : null)  : e.target.value
    });
  };
  const handleSelectUser = (e, item) => {
    setForm({ ...form, user_id: item.id, username: item.value });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.user_id) {
      toast('Please select the producer who will host this Parlour.', { type: 'error' });
      return;
    }
    try {
      const { username, ...payload } = form;
      props.setLoading(true);
      // Uploads the poster/intro via the presigned flow and posts to
      // `POST /admin/scheduler-parlours`. Resolves `false` on failure (the
      // wrapper has already explained why), so bail out rather than adding an
      // `undefined` row to the list.
      const result = await props.createSchedulerParlour(payload);
      if (!result) return;
      props.addParlour(result.data);
      props.toggleModalForm();
    } catch (error) { }
    finally {
      props.setLoading(false);
    }
  }
  return (
    <Form className="create-parlour" >
      <FormGroup className="user-search-control">
        <Label for="username">Select User</Label>
        <UserSelectComponent 
          id="username"
          name="username"
          value={form.username}
          onChange={(e) => handleChange(e, 'username')}
          onSelect={handleSelectUser}
        />
      </FormGroup>
      <FormGroup>
        <Label for="suite_title">Title</Label>
        <Input type="text" autoFocus name="suite_title" value={form.suite_title} id="suite_title" placeholder="Enter title" onChange={handleChange} required />
      </FormGroup>
      <FormGroup>
        <Label for="price">Recording price</Label>
        {/* A free number input let staff type any amount, which the API then
            rejected: the recording price is one of four FIXED tiers
            (GET /parlours/prices → 0/100/300/500 cents) and anything else is a
            400. Offering only the real tiers makes an invalid price
            unrepresentable rather than a rejected submit. Live attendance is
            always free — this prices the recording. */}
        <select
          name="price"
          id="price"
          className="form-control"
          value={form.price}
          onChange={handleChange}
          required
        >
          <option value="0">Free</option>
          <option value="1">$1</option>
          <option value="3">$3</option>
          <option value="5">$5</option>
        </select>
      </FormGroup>
      <FormGroup className="file-field">
        <Label for="poster">Poster</Label>
        <div className="add-file-btn">
          <Input 
            type="file"
            id="poster"
            name="poster"
            onChange={handleChange}
            accept="image/*"
            required
          />
        </div>
        <div className='image-preview'>
          {form.poster && (
            <img src={URL.createObjectURL(form.poster)} alt="poster" className='img-thumbnail' />
          )}
        </div>
      </FormGroup>
      <FormGroup className="file-field">
        <Label for="video_intro">Video Intro</Label>
        <div className="add-file-btn">
          <Input 
            type="file"
            id="video_intro"
            name="video_intro"
            onChange={handleChange}
            accept="video/*"
            required
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Label for="start_date">Start Date</Label>
        <Input type="datetime-local" name="start_date" value={form.start_date} id="start_date" placeholder="Enter start date" onChange={handleChange} required />
      </FormGroup>
      {/* The member picker was removed with the v2 create wiring: the API's
          create takes no members (the app's own Schedule Parlour doesn't invite
          at creation either — attendees RSVP, and participants are viewed via
          /admin/scheduler-parlours/:id/participants). Keeping the control would
          have let staff add members that were silently dropped from the
          payload, which is the same "looks wired, isn't" failure as the rest of
          this batch. Re-add it only alongside real invite support. */}
      <FormGroup className="btn-wrap">
        <Button color="primary" onClick={handleSubmit} disabled={props.loading} >
          {props.loading ? 'Loading...' : 'Create'}
        </Button>
      </FormGroup>
    </Form>
  )
}

export default connect(null, {
  createSchedulerParlour,
})(withRouter(FormParlour));